var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.$lang('家庭成員: ')))]),_c('ul',{staticClass:"list"},_vm._l((_vm.list),function(item,index){return _c('li',{key:index},[_c('span',{staticClass:"point"}),_vm._v(_vm._s(_vm.changeName(item)))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }